  document.querySelectorAll('.quickbuy-button').forEach(atcBtn => {
    atcBtn.addEventListener('click', function (e) {
        const variantId = this.dataset.variantId

        fetch('/cart/add.js', {
            method : 'POST',
            headers : {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: variantId,
                quantity: 1
            })
        }).then (res => {
            if(res.status == 200) {
                // Check if cart drawer functionality is available
                if (typeof refreshCartDrawerAndOpen === 'function') {
                    refreshCartDrawerAndOpen();
                } else {
                    // Fallback to cart page
                    window.location.href = '/cart'
                }
            }
        })
    })
})

/**
 * Back Button Navigation Fix
 * Resolves page freeze on browser back button for product pages (desktop)
 */

(function() {

  // ── FIX 1: Handle popstate (History API) ──────────────────────────────────
  // Forces a real page reload when the user presses Back/Forward.
  // This is the safest fix if your theme uses pushState for variant URLs.
  window.addEventListener('popstate', function(event) {
    // Only reload if we're navigating to/from a product page
    if (
      window.location.pathname.includes('/products/') ||
      (event.state && event.state.url && event.state.url.includes('/products/'))
    ) {
      window.location.reload();
    }
  });


  // ── FIX 2: Clean up body overflow on Back navigation ─────────────────────
  // SSW modals and cart drawers set overflow:hidden on body.
  // This ensures it's always cleared when navigating back.
  window.addEventListener('pageshow', function(event) {
    // pageshow fires on back/forward cache (bfcache) restores too
    document.body.style.overflow = '';
    document.body.classList.remove('overflow-hidden', 'modal-open', 'drawer-open');
    document.documentElement.style.overflow = '';

    // Close any open SSW modals
    const sswModals = document.querySelectorAll('.ssw-modal, .ssw-cart-modal, [class*="ssw"][class*="modal"]');
    sswModals.forEach(function(modal) {
      modal.style.display = 'none';
      modal.setAttribute('aria-hidden', 'true');
    });

    // Close cart drawer if open
    const cartDrawer = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer');
    if (cartDrawer) {
      cartDrawer.removeAttribute('open');
      cartDrawer.setAttribute('aria-hidden', 'true');
    }
  });


  // ── FIX 3: Prevent bfcache issues ────────────────────────────────────────
  // Some browsers restore pages from cache (bfcache) in a broken state.
  // This forces a reload if the page was restored from bfcache.
  window.addEventListener('pageshow', function(event) {
    if (event.persisted) {
      // Page was restored from bfcache — reload to get fresh state
      window.location.reload();
    }
  });

})();
